import React from "react";
import PropTypes from "prop-types";
import DesktopUpperFooter from "./DesktopUpperFooter";
import MobileFooter from "./MobileFooter";
import useViewport from "~/assets/js/Helpers/hooks/useViewport";
import DesktopCartFooter from "./DesktopCartFooter";

const Footer = ({ customCondition = true }) => {
    const { isDesktop } = useViewport();
    if (isDesktop && customCondition) {
        return (
            <div className="container">
                <DesktopUpperFooter />
                <DesktopCartFooter />
            </div>
        );
    }

    return (
        <div className="container">
            <MobileFooter />
        </div>
    );
};

Footer.propTypes = {
    customCondition: PropTypes.bool,
};

export default Footer;
